import { Icon, Hyperlink } from '@openedx/paragon';

import type { SocialLink } from './types';

const SocialLinks = ({ socialLinks }: { socialLinks: SocialLink[] }) => (
  <>
    {socialLinks.map((link) => (
      <Hyperlink
        key={link.id}
        className={`course-about-sidebar__social-link course-about-sidebar__social-link--${link.id}`}
        destination={link.destination}
        onClick={link.onClick}
      >
        <Icon
          className={`course-about-sidebar__social-icon course-about-sidebar__social-icon--${link.id}`}
          src={link.icon}
          screenReaderText={link.screenReaderText}
          size="lg"
        />
      </Hyperlink>
    ))}
  </>
);

export default SocialLinks;
